'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Locale = require('./lang/Locale');

var _Locale2 = _interopRequireDefault(_Locale);

var _logo = require('./images/indexV2/logo.png');

var _logo2 = _interopRequireDefault(_logo);

var _dld_qrcode = require('./images/dld_qrcode.png');

var _dld_qrcode2 = _interopRequireDefault(_dld_qrcode);

var _phoneDown = require('./images/indexV2/phone-down.png');

var _phoneDown2 = _interopRequireDefault(_phoneDown);

var _gzhQrcode = require('./images/indexV2/gzh-qrcode.png');

var _gzhQrcode2 = _interopRequireDefault(_gzhQrcode);

var _icoMail = require('./images/indexV2/ico-mail.png');

var _icoMail2 = _interopRequireDefault(_icoMail);

var _icoQq = require('./images/indexV2/ico-qq.png');

var _icoQq2 = _interopRequireDefault(_icoQq);

var _icoAbout = require('./images/indexV2/ico-about.png');

var _icoAbout2 = _interopRequireDefault(_icoAbout);

var _icoGzh = require('./images/indexV2/ico-gzh.png');

var _icoGzh2 = _interopRequireDefault(_icoGzh);

var _icons = require('./images/icons.png');

var _icons2 = _interopRequireDefault(_icons);

require('./WebIndexV2.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

require('url-search-params-polyfill');

var WebIndexForXP = function (_React$Component) {
    _inherits(WebIndexForXP, _React$Component);

    function WebIndexForXP() {
        var _ref;

        var _temp, _this2, _ret;

        _classCallCheck(this, WebIndexForXP);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = WebIndexForXP.__proto__ || Object.getPrototypeOf(WebIndexForXP)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
            beianText: '京ICP备18016017号-7',
            companyEnName: 'Beijing Xiaowei Cloud Inc.',
            downloadHost: 'https://download.xdiarys.com',
            downloadFileName: '/windows/xdiarys-setup-xp.exe',
            macOSUrl: '',
            iOSUrl: '',
            helpRecent: [],
            showBeianText: false,
            showHelp: false,
            isWindow: true,
            contantUsQQWindows: '',
            contantUsQQMacos: '',
            contantUsEmail: 'service@xiaoweiyunfu.com',
            showDownload: false,
            updateTime: '',
            version: '',
            showLinkArea: false
        }, _temp), _possibleConstructorReturn(_this2, _ret);
    }

    _createClass(WebIndexForXP, [{
        key: 'componentWillMount',
        value: function componentWillMount() {

            var search = new URLSearchParams(location.search);

            var paramTN = search.get("tn");
            var src = search.get("src");

            // 初始化语言设置
            var local = _Locale2["default"].GetInstance();
            local.InitLang(null, navigator.language || navigator.userLanguage);

            document.title = local.getMessagebyId('www_title');

            document.querySelector('meta[name="keywords"]').setAttribute('content', local.getMessagebyId('www_keywords'));
            document.querySelector('meta[name="description"]').setAttribute('content', local.getMessagebyId('www_description'));

            var lang = local.getLang();
            if (lang === 'chs') {

                this.GetRecentHelp();
                this.GetContantUs();

                this.setState({ showBeianText: true, showHelp: true, downloadHost: 'https://download.xdiarys.com' });
                this.setState({ showLinkArea: true });
            }

            var country = 'us';
            if (lang == 'chs') {
                country = 'cn';
            } else if (lang == 'cht') {
                country = 'tw';
            } else if (lang == 'kor') {
                country = 'kr';
            }

            var macOSUrl = 'https://apps.apple.com/' + country + '/app/CalendarTask/id1570563588';
            var iOSUrl = 'https://apps.apple.com/' + country + '/app/CalendarTask/id1570563588?platform=iphone';
            this.setState({ macOSUrl: macOSUrl, iOSUrl: iOSUrl });

            this.state.opSystem = this.getOperatingSystem();

            this.handleScroll = this.handleScroll.bind(this);

            window.addEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var windows_btn = document.getElementById('windows_btn');
            windows_btn.addEventListener("click", function () {
                window._hmt.push(['_trackEvent', 'xdiarys', 'click', 'windows_btn', 1]);
            });

            var macos_btn = document.getElementById('macos_btn');
            macos_btn.addEventListener("click", function () {
                window._hmt.push(['_trackEvent', 'xdiarys', 'click', 'macos_btn', 1]);
            });

            var ios_btn = document.getElementById('ios_btn');
            ios_btn.addEventListener("click", function () {
                window._hmt.push(['_trackEvent', 'xdiarys', 'click', 'ios_btn', 1]);
            });

            var android_btn = document.getElementById('android_btn');
            android_btn.addEventListener("click", function () {
                window._hmt.push(['_trackEvent', 'xdiarys', 'click', 'android_btn', 1]);
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(event) {

            var scroll = document.documentElement.scrollTop || document.body.scrollTop;

            if (scroll && this.state.isWindow && this.state.opSystem != 'linux' && this.state.opSystem != 'macos') {
                this.setState({ showDownload: true });
            } else {
                this.setState({ showDownload: false });
            }

            var lastScrollY = window.scrollY || window.pageYOffset;
            window.addEventListener('scroll', function () {
                var floatingBox = document.querySelector('.floating-box');
                var currentScrollY = window.scrollY || window.pageYOffset;

                if (currentScrollY > lastScrollY) {
                    // 向下滚动
                    floatingBox.classList.remove('bounce-up-animation');
                    floatingBox.classList.add('bounce-down-animation');
                    floatingBox.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.2)';
                } else if (currentScrollY < lastScrollY) {
                    // 向上滚动
                    floatingBox.classList.remove('bounce-down-animation');
                    floatingBox.classList.add('bounce-up-animation');
                    floatingBox.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.1)';
                }

                // 更新上一次的滚动位置
                lastScrollY = currentScrollY;
            });
        }
    }, {
        key: 'GetRecentHelp',
        value: function GetRecentHelp() {

            var _this = this;

            fetch('/api/help/recent/8', {
                method: "GET",
                credentials: 'include',
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (myJson) {
                var currenthelpRecent = _this.state.helpRecent;

                myJson.posts.forEach(function (element) {
                    currenthelpRecent.push(_react2["default"].createElement(
                        'div',
                        { className: 'helplink', key: element.url },
                        _react2["default"].createElement(
                            'a',
                            { href: element.url, className: 'top1' },
                            element.title
                        )
                    ));
                });

                _this.setState({ helpRecent: currenthelpRecent });
                return myJson;
            })["catch"](function (e) {
                console.log(e);
            });
        }
    }, {
        key: 'GetContantUs',
        value: function GetContantUs() {
            var _this = this;

            fetch('/api/help/contantus', {
                method: "GET",
                credentials: 'include',
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (myJson) {

                _this.setState({ contantUsQQWindows: myJson.vdata.qqwindow });
                _this.setState({ contantUsQQMacos: myJson.vdata.qqmacos });
                _this.setState({ contantUsEmail: myJson.vdata.email });

                return myJson;
            })["catch"](function (e) {
                console.log(e);
            });
        }
    }, {
        key: 'getOperatingSystem',
        value: function getOperatingSystem() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            if (userAgent.indexOf("Windows NT") > -1) {
                return "windows";
            }
            if (userAgent.indexOf("Mac OS X") > -1) {
                return "macos";
            }
            if (userAgent.indexOf("Linux") > -1) {
                return "linux";
            }
            if (/Android/.test(userAgent)) {
                return "android";
            }
            if (/like Mac OS X/.test(userAgent)) {
                return "ios";
            }

            return "unknown";
        }
    }, {
        key: 'breakLine',
        value: function breakLine(text) {
            var br = _react2["default"].createElement('br');
            var regex = /(<br \/>)/g;
            return text.split(regex).map(function (line, index) {
                alert(text);
                return line.match(regex) ? _react2["default"].createElement('br', { key: "key_" + index }) : line;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var local = _Locale2["default"].GetInstance();
            var moreFunction = local.getMessagebyId('more_function');
            var titleText = local.getMessagebyId('www_title');
            var updateLog = local.getMessagebyId('update_log');

            var about_us = local.getMessagebyId('v2_about_us');

            var slogan_text = local.getMessagebyId('v2_slogan_text');

            var feature_text = local.getMessagebyId('v2_feature_title');

            //更新版本和时间
            var v2_update_time = local.getMessagebyId('v2_update_time');
            var v2_update_ver = local.getMessagebyId('v2_update_ver');

            //底部其他特色
            var v2_feature_other = local.getMessagebyId('v2_feature_other');

            var v2_feature_other_1_title = local.getMessagebyId('v2_feature_other_1_title');
            var v2_feature_other_1_html = local.getMessagebyId('v2_feature_other_1_html');

            var v2_feature_other_2_title = local.getMessagebyId('v2_feature_other_2_title');
            var v2_feature_other_2_html = local.getMessagebyId('v2_feature_other_2_html');

            var v2_feature_other_3_title = local.getMessagebyId('v2_feature_other_3_title');
            var v2_feature_other_3_html = local.getMessagebyId('v2_feature_other_3_html');

            var copy_right = local.getMessagebyId('copy_right');

            var csan_text = local.getMessagebyId('v2_scan');
            var csan_down_text = local.getMessagebyId('v2_down_phone');

            var slogan_text3 = local.getMessagebyId('slogan_text3');
            var windows_button = local.getMessagebyId('v2_button_down_xp');
            var other_button = local.getMessagebyId('v2_button_down_other');
            var scan_download_phone = local.getMessagebyId('scan_download_phone');

            var lang = local.getLang();

            var mainPic = require('./images/indexV2/main-pic-chs.png');

            var img1 = require('./images/indexV2/img1-chs.png');
            var img2 = require('./images/indexV2/img2-chs.png');
            var img3 = require('./images/indexV2/img3-chs.png');
            var img4 = require('./images/indexV2/img4-chs.png');
            var img5 = require('./images/indexV2/img5-chs.png');
            var img6 = require('./images/indexV2/img6-chs.png');
            var img7 = require('./images/indexV2/img7-chs.png');
            if (lang === 'chs') {} else if (lang === 'cht' || lang === 'kor' || lang === 'usa') {
                mainPic = require('./images/indexV2/main-pic-' + lang + '.png');
                img1 = require('./images/indexV2/img1-' + lang + '.png');
                img2 = require('./images/indexV2/img2-' + lang + '.png');
                img3 = require('./images/indexV2/img3-' + lang + '.png');
                img4 = require('./images/indexV2/img4-' + lang + '.png');
                img5 = require('./images/indexV2/img5-' + lang + '.png');
                img6 = require('./images/indexV2/img6-' + lang + '.png');
            }

            var content_title1 = "";
            var content_title2 = "";
            var content_title3 = "";
            var content_title4 = "";
            var content_title5 = "";
            var content_title_note = "";
            var content_title_noad = "";

            var content_text1 = "";
            var content_text2 = "";
            var content_text3 = "";
            var content_text4 = "";
            var content_text5 = "";
            var content_text_note = "";
            var content_text_noad = "";

            if (lang === 'chs') {
                content_title1 = local.getMessagebyId('content_title_win1');
                content_title2 = local.getMessagebyId('content_title_win2');
                content_title3 = local.getMessagebyId('content_title_win3');
                content_title4 = local.getMessagebyId('content_title_win4');
                content_title5 = local.getMessagebyId('content_title_win5');
                content_text1 = local.getMessagebyId('content_text_win1');
                content_text2 = local.getMessagebyId('content_text_win2');
                content_text3 = local.getMessagebyId('content_text_win3');
                content_text4 = local.getMessagebyId('content_text_win4');
                content_text5 = local.getMessagebyId('content_text_win5');

                content_title_note = local.getMessagebyId('v2_content_title_note');
                content_title_noad = local.getMessagebyId('v2_content_title_noad');
                content_text_note = local.getMessagebyId('v2_content_text_note');
                content_text_noad = local.getMessagebyId('v2_content_text_noad');
            } else {
                content_title1 = local.getMessagebyId('content_title2');
                content_text1 = local.getMessagebyId('content_text2');

                content_title2 = local.getMessagebyId('content_title1');
                content_text2 = local.getMessagebyId('content_text1');

                content_title3 = local.getMessagebyId('v2_content_title_reminder');
                content_text3 = local.getMessagebyId('v2_content_text_reminder');

                content_title4 = local.getMessagebyId('v2_content_title_countdown');
                content_text4 = local.getMessagebyId('v2_content_text_countdown');

                content_title_note = local.getMessagebyId('v2_content_title_note');
                content_title_noad = local.getMessagebyId('v2_content_title_noad');
                content_text_note = local.getMessagebyId('v2_content_text_note');
                content_text_noad = local.getMessagebyId('v2_content_text_noad');
            }

            return _react2["default"].createElement(
                'div',
                { className: 'v2-html' },
                _react2["default"].createElement(
                    'div',
                    { className: 'v2-all' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'v2-top' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'v2-top-contain' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'w45 float-left aling-left logo-area' },
                                _react2["default"].createElement('img', { className: 'logo', src: _logo2["default"] }),
                                _react2["default"].createElement(
                                    'span',
                                    { className: 'title' },
                                    titleText
                                )
                            ),
                            _react2["default"].createElement(
                                'div',
                                { className: 'more-area w45 float-right' },
                                _react2["default"].createElement(
                                    'span',
                                    { className: 'more-link' },
                                    _react2["default"].createElement(
                                        'a',
                                        { href: 'https://help.xdiarys.com/?page_id=177' },
                                        updateLog
                                    )
                                ),
                                _react2["default"].createElement(
                                    'span',
                                    { className: 'more-link' },
                                    _react2["default"].createElement(
                                        'a',
                                        { href: 'https://www.xdiarys.com/baseintro' },
                                        moreFunction
                                    )
                                )
                            )
                        )
                    ),
                    this.state.showDownload && _react2["default"].createElement(
                        'div',
                        { className: 'v2-top-float' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'v2-top-contain' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'w45 float-left aling-left logo-area' },
                                _react2["default"].createElement('img', { className: 'logo', src: _logo2["default"] }),
                                _react2["default"].createElement(
                                    'span',
                                    { className: 'title' },
                                    titleText
                                )
                            ),
                            _react2["default"].createElement(
                                'div',
                                { className: 'more-area-down w200px float-right' },
                                _react2["default"].createElement(
                                    'a',
                                    { id: 'windows_btn', className: 'win-btn', href: this.state.downloadHost + this.state.downloadFileName },
                                    _react2["default"].createElement('div', { className: 'image' }),
                                    windows_button
                                )
                            )
                        )
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'v2-main' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'main-contain' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'main-slogan' },
                                slogan_text
                            ),
                            _react2["default"].createElement('div', { className: 'main-feature',
                                dangerouslySetInnerHTML: {
                                    __html: feature_text
                                } }),
                            _react2["default"].createElement(
                                'div',
                                { className: 'main-down' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'down-btn' },
                                    function () {

                                        return _react2["default"].createElement(
                                            'div',
                                            null,
                                            _react2["default"].createElement(
                                                'a',
                                                { id: 'windows_btn', className: 'win-btn', href: _this3.state.downloadHost + _this3.state.downloadFileName },
                                                _react2["default"].createElement('div', { className: 'image' }),
                                                windows_button
                                            ),
                                            _react2["default"].createElement('div', { className: 'blank' }),
                                            _react2["default"].createElement(
                                                'a',
                                                { id: 'macos_btn', className: 'linux-btn other', href: "/" },
                                                other_button
                                            )
                                        );
                                    }()
                                )
                            ),
                            this.state.version !== '' ? _react2["default"].createElement(
                                'div',
                                { className: 'main-ver' },
                                v2_update_time,
                                ' : ',
                                this.state.updateTime,
                                _react2["default"].createElement('span', { className: 'ver-gap' }),
                                _react2["default"].createElement(
                                    'span',
                                    { className: 'ver-gap' },
                                    '|'
                                ),
                                _react2["default"].createElement('span', { className: 'ver-gap' }),
                                v2_update_ver,
                                ' : ',
                                this.state.version
                            ) : _react2["default"].createElement('div', { className: 'main-ver' }),
                            _react2["default"].createElement(
                                'div',
                                { className: 'main-cover' },
                                _react2["default"].createElement('img', { className: 'main-pic', src: mainPic })
                            )
                        )
                    ),
                    lang === 'chs' ? _react2["default"].createElement(
                        'div',
                        null,
                        _react2["default"].createElement(
                            'div',
                            { className: 'feature-block bg1' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'contain bg-img1' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c1-left' },
                                    _react2["default"].createElement('img', { className: 'feature-img', width: 459, height: 300, src: img1 })
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c1-right' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'feature-desc' },
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-title' },
                                            content_title1,
                                            _react2["default"].createElement('span', { className: 'feature-dot' })
                                        ),
                                        _react2["default"].createElement('br', null),
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-content' },
                                            content_text1
                                        )
                                    )
                                )
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'feature-block bg2' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'contain bg-img2' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c2-left b2-left' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'feature-desc' },
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-title' },
                                            content_title2
                                        ),
                                        _react2["default"].createElement('br', null),
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-content' },
                                            content_text2
                                        )
                                    )
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c2-right b2-right' },
                                    _react2["default"].createElement('img', { className: 'feature-img', width: 585, height: 408, src: img2 })
                                )
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'feature-block bg1' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'contain bg-img3' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c1-left t b3-left' },
                                    _react2["default"].createElement('img', { className: 'feature-img', width: 596, height: 334, src: img3 })
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c1-right b3-right' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'feature-desc' },
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-title' },
                                            content_title3,
                                            _react2["default"].createElement('span', { className: 'feature-dot' })
                                        ),
                                        _react2["default"].createElement('br', null),
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-content' },
                                            content_text3
                                        )
                                    )
                                )
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'feature-block bg2' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'contain bg-img4' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c2-left b4-left' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'feature-desc' },
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-title' },
                                            content_title4
                                        ),
                                        _react2["default"].createElement('br', null),
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-content' },
                                            content_text4
                                        )
                                    )
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c2-right  b4-right' },
                                    _react2["default"].createElement('img', { className: 'feature-img', width: 559, height: 312, src: img4 })
                                )
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'feature-block bg1' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'contain bg-img5' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c1-left  b5-left' },
                                    _react2["default"].createElement('img', { className: 'feature-img', width: 505, height: 343, src: img5 })
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c1-right  b5-right' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'feature-desc' },
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-title' },
                                            content_title_note,
                                            _react2["default"].createElement('span', { className: 'feature-dot' })
                                        ),
                                        _react2["default"].createElement('br', null),
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-content' },
                                            content_text_note
                                        )
                                    )
                                )
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'feature-block bg2' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'contain bg-img6' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c2-left b6-left' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'feature-desc' },
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-title' },
                                            content_title5
                                        ),
                                        _react2["default"].createElement('br', null),
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-content' },
                                            content_text5
                                        )
                                    )
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c2-right b6-right' },
                                    _react2["default"].createElement('img', { className: 'feature-img', width: 582, height: 381, src: img6 })
                                )
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'feature-block bg1' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'contain bg-img7' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c1-left  b7-left' },
                                    _react2["default"].createElement('img', { className: 'feature-img', width: 494, height: 335, src: img7 })
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c1-right  b7-right' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'feature-desc' },
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-title' },
                                            content_title_noad,
                                            _react2["default"].createElement('span', { className: 'feature-dot' })
                                        ),
                                        _react2["default"].createElement('br', null),
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-content' },
                                            content_text_noad
                                        )
                                    )
                                )
                            )
                        )
                    ) : _react2["default"].createElement(
                        'div',
                        null,
                        _react2["default"].createElement(
                            'div',
                            { className: 'feature-block bg1' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'contain bg-img3' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c1-left t b1-left' },
                                    _react2["default"].createElement('img', { className: 'feature-img', width: 459, height: 300, src: img1 })
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c1-right b1-right' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'feature-desc' },
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-title' },
                                            content_title1,
                                            _react2["default"].createElement('span', { className: 'feature-dot' })
                                        ),
                                        _react2["default"].createElement('br', null),
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-content' },
                                            content_text1
                                        )
                                    )
                                )
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'feature-block bg2' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'contain bg-img4' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c2-left sync-left' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'feature-desc' },
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-title' },
                                            content_title2
                                        ),
                                        _react2["default"].createElement('br', null),
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-content' },
                                            content_text2
                                        )
                                    )
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c2-right  sync-right' },
                                    _react2["default"].createElement('img', { className: 'feature-img', width: 596, height: 334, src: img2 })
                                )
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'feature-block bg1' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'contain bg-img5' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c1-left  reminder-left' },
                                    _react2["default"].createElement('img', { className: 'feature-img', width: 505, height: 343, src: img3 })
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c1-right  reminder-right' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'feature-desc' },
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-title' },
                                            content_title3,
                                            _react2["default"].createElement('span', { className: 'feature-dot' })
                                        ),
                                        _react2["default"].createElement('br', null),
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-content' },
                                            content_text3
                                        )
                                    )
                                )
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'feature-block bg2' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'contain bg-img6' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c2-left note-left' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'feature-desc' },
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-title' },
                                            content_title_note
                                        ),
                                        _react2["default"].createElement('br', null),
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-content' },
                                            content_text_note
                                        )
                                    )
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c2-right note-right' },
                                    _react2["default"].createElement('img', { className: 'feature-img', width: 535, height: 353, src: img4 })
                                )
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'feature-block bg1' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'contain bg-img7' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c1-left  down-left' },
                                    _react2["default"].createElement('img', { className: 'feature-img', width: 582, height: 381, src: img5 })
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c1-right  down-right' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'feature-desc' },
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-title' },
                                            content_title4,
                                            _react2["default"].createElement('span', { className: 'feature-dot' })
                                        ),
                                        _react2["default"].createElement('br', null),
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-content' },
                                            content_text4
                                        )
                                    )
                                )
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'feature-block bg2 mb-40' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'contain' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c2-left b6-left' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'feature-desc' },
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-title' },
                                            content_title_noad
                                        ),
                                        _react2["default"].createElement('br', null),
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'feature-content' },
                                            content_text_noad
                                        )
                                    )
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'c2-right b6-right' },
                                    _react2["default"].createElement('img', { className: 'feature-img', width: 582, height: 381, src: img6 })
                                )
                            )
                        )
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'feature-block-other' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'block-title' },
                            v2_feature_other
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'contain' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'other-col1' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'other-title' },
                                    v2_feature_other_1_title
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'other-content' },
                                    _react2["default"].createElement('ul', { dangerouslySetInnerHTML: {
                                            __html: v2_feature_other_1_html
                                        } })
                                )
                            ),
                            _react2["default"].createElement(
                                'div',
                                { className: 'other-col2' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'other-title' },
                                    v2_feature_other_2_title
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'other-content' },
                                    _react2["default"].createElement('ul', { dangerouslySetInnerHTML: {
                                            __html: v2_feature_other_2_html
                                        } })
                                )
                            ),
                            _react2["default"].createElement(
                                'div',
                                { className: 'other-col3' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'other-title' },
                                    v2_feature_other_3_title
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'other-content' },
                                    _react2["default"].createElement('ul', { dangerouslySetInnerHTML: {
                                            __html: v2_feature_other_3_html
                                        } })
                                )
                            )
                        )
                    ),
                    this.state.showLinkArea ? _react2["default"].createElement(
                        'div',
                        { className: 'v2-link' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'v2-link-contain' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'section help-section' },
                                _react2["default"].createElement(
                                    'h2',
                                    null,
                                    '\u5E2E\u52A9'
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'columns' },
                                    _react2["default"].createElement(
                                        'ul',
                                        null,
                                        _react2["default"].createElement(
                                            'li',
                                            null,
                                            _react2["default"].createElement(
                                                'a',
                                                { href: 'https://help.xdiarys.com/?p=673' },
                                                '\u4FEE\u6539\u5B89\u88C5\u8DEF\u5F84\u540E\uFF0C\u6570\u636E\u4E22\u5931'
                                            )
                                        ),
                                        _react2["default"].createElement(
                                            'li',
                                            null,
                                            _react2["default"].createElement(
                                                'a',
                                                { href: 'https://help.xdiarys.com/?p=663' },
                                                'Win7\u7248\u672C\u9ED1\u5C4F\uFF08\u82B1\u5C4F\uFF09\u7684\u95EE\u9898'
                                            )
                                        ),
                                        _react2["default"].createElement(
                                            'li',
                                            null,
                                            _react2["default"].createElement(
                                                'a',
                                                { href: 'https://help.xdiarys.com/?p=647' },
                                                '\u5982\u4F55\u67E5\u770B\u65E5\u5386\u7684\u7528\u6237ID'
                                            )
                                        ),
                                        _react2["default"].createElement(
                                            'li',
                                            null,
                                            _react2["default"].createElement(
                                                'a',
                                                { href: 'https://help.xdiarys.com/?p=637' },
                                                '\u624B\u673A\u7AEF\u5982\u4F55\u7ED1\u5B9A\u90AE\u7BB1'
                                            )
                                        )
                                    ),
                                    _react2["default"].createElement(
                                        'ul',
                                        null,
                                        _react2["default"].createElement(
                                            'li',
                                            null,
                                            _react2["default"].createElement(
                                                'a',
                                                { href: 'https://help.xdiarys.com/?p=626' },
                                                '\u5982\u4F55\u67E5\u627E\u65E5\u5386\u6E05\u5355\u7684\u6570\u636E\u6587\u4EF6'
                                            )
                                        ),
                                        _react2["default"].createElement(
                                            'li',
                                            null,
                                            _react2["default"].createElement(
                                                'a',
                                                { href: 'https://help.xdiarys.com/?p=594' },
                                                '\u5982\u4F55\u89E3\u51B3\u65E5\u5386\u6E05\u5355\u4E0D\u540C\u6B65'
                                            )
                                        ),
                                        _react2["default"].createElement(
                                            'li',
                                            null,
                                            _react2["default"].createElement(
                                                'a',
                                                { href: 'https://help.xdiarys.com/?p=588' },
                                                '\u65E5\u5386\u6E05\u5355PC\u7535\u8111\u7248\u5B89\u88C5\u5728\u54EA\u91CC'
                                            )
                                        ),
                                        _react2["default"].createElement(
                                            'li',
                                            null,
                                            _react2["default"].createElement(
                                                'a',
                                                { href: 'https://help.xdiarys.com/?p=510' },
                                                '\u7535\u8111\u7AEF\u5FAE\u4FE1\u767B\u5F55\u6309\u94AE\uFF0C\u70B9\u51FB\u65E0\u6548'
                                            )
                                        )
                                    )
                                )
                            ),
                            _react2["default"].createElement('div', { className: 'divider' }),
                            _react2["default"].createElement(
                                'div',
                                { className: 'section contact-section' },
                                _react2["default"].createElement(
                                    'h2',
                                    null,
                                    '\u8054\u7CFB\u6211\u4EEC'
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'columns' },
                                    _react2["default"].createElement(
                                        'ul',
                                        null,
                                        _react2["default"].createElement(
                                            'li',
                                            null,
                                            _react2["default"].createElement('img', { src: _icoMail2["default"], className: 'contact-ico', alt: 'Email' }),
                                            this.state.contantUsEmail
                                        ),
                                        _react2["default"].createElement(
                                            'li',
                                            { className: 'qqlink' },
                                            _react2["default"].createElement('img', { src: _icoQq2["default"], className: 'contact-ico', alt: 'QQ' }),
                                            'PC QQ\u7FA4\uFF1A',
                                            this.state.contantUsQQWindows,
                                            _react2["default"].createElement('br', null),
                                            _react2["default"].createElement(
                                                'span',
                                                { className: 'qqline2' },
                                                'Mac QQ\u7FA4\uFF1A',
                                                this.state.contantUsQQMacos
                                            )
                                        ),
                                        _react2["default"].createElement(
                                            'li',
                                            null,
                                            _react2["default"].createElement('img', { src: _icoAbout2["default"], className: 'contact-ico', alt: '\u5173\u4E8E\u6211\u4EEC' }),
                                            _react2["default"].createElement(
                                                'a',
                                                { href: 'https://www.xdiarys.com/aboutus' },
                                                '\u5173\u4E8E\u6211\u4EEC'
                                            )
                                        )
                                    ),
                                    _react2["default"].createElement(
                                        'ul',
                                        null,
                                        _react2["default"].createElement(
                                            'li',
                                            null,
                                            _react2["default"].createElement('img', { src: _icoGzh2["default"], className: 'contact-ico', alt: 'WeChat' }),
                                            '\u516C\u4F17\u53F7',
                                            _react2["default"].createElement('br', null),
                                            _react2["default"].createElement(
                                                'span',
                                                { className: 'gzh-qrcode' },
                                                _react2["default"].createElement('img', { src: _gzhQrcode2["default"] })
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    ) : null,
                    _react2["default"].createElement(
                        'div',
                        { className: 'v2-bottom' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'bottom-area' },
                            this.state.showLinkArea ? null : _react2["default"].createElement(
                                'div',
                                { className: 'bottom-link' },
                                _react2["default"].createElement('img', { src: _icoMail2["default"], className: 'link-ico', alt: 'Email' }),
                                ' ',
                                this.state.contantUsEmail
                            ),
                            copy_right,
                            ' \xA0',
                            this.state.companyEnName,
                            '  ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'privacypolicy' },
                                'Privacy Policy'
                            ),
                            ' / ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'eula' },
                                'EULA'
                            ),
                            this.state.showBeianText ? _react2["default"].createElement(
                                'span',
                                { className: 'beian' },
                                '\xA0\xA0\xA0|\xA0\xA0\xA0 ',
                                _react2["default"].createElement(
                                    'a',
                                    { className: 'link', href: 'http://beian.miit.gov.cn/' },
                                    ' ',
                                    this.state.beianText
                                )
                            ) : null
                        )
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'floating-box' },
                    _react2["default"].createElement('img', { src: _phoneDown2["default"] }),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        _react2["default"].createElement(
                            'p',
                            { className: 'scan-text' },
                            csan_text
                        ),
                        _react2["default"].createElement(
                            'p',
                            { className: 'download-text' },
                            csan_down_text
                        )
                    )
                )
            );
        }
    }]);

    return WebIndexForXP;
}(_react2["default"].Component);

exports["default"] = WebIndexForXP;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./WebIndexForXP.js
// module id = 632
// module chunks = 0